<template>
  <el-row
    class="bind-wrapper"
    v-loading="pageLoading"
  >
    <!-- <header class="wx-bind-header">
      <img
        class="logo"
        alt="Hamlet"
        src="../assets/logos/hamlet.svg"
      >
      <el-row class="user-info">
        <span class="avatar"><i class="iconfont icon-user"></i></span>
        <span>{{ bindInfo.username }}</span>
      </el-row>
    </header> -->

    <!-- 绑定相关 -->
    <div class="acConnect">
      <!-- 登录成功 -->
      <template v-if="!successfullyBound && !applyUnbinding">
        <app-logo :app-name="bindInfo.app_name" />
        <div class="acConnect__text">
          <h1 class="acConnect__text-title">{{ $t('thirdPartyLogin.successfulLogin') }}</h1>
          <p class="acConnect__text-descr">
            {{ $t(`thirdPartyLogin.${isForceWeixinLogin ? 'needWeChat' : 'recommendWeChat'}`, { app: bindInfo.app_name }) }}
          </p>
        </div>
        <div class="acConnect__btns">
          <el-button
            class="acConnect__btns-item"
            size="medium"
            @click="toBindWx"
            :loading="binding"
            type="primary"
          >
            {{ isMiniprogram ? $t('thirdPartyLogin.bind') : $t('thirdPartyLogin.completeBinding') }}
          </el-button>
          <div class="acConnect__btns-cancel">
            <el-button
              v-if="isMiniprogram"
              class="acConnect__btns-item"
              size="medium"
              @click="toLoginPage"
              :disabled="binding"
              plain
            >{{ $t('common.cancel') }}</el-button>
            <el-button
              v-else
              class="acConnect__btns-item"
              size="medium"
              @click="toReturnUrl"
            >
              {{ isForceWeixinLogin ? $t('thirdPartyLogin.logout') : $t('thirdPartyLogin.doNotRemindAgain') }}
            </el-button>
            <p class="acConnect__btns-cancelDescr">{{ $t('thirdPartyLogin.unbindPrompt') }}</p>
          </div>
        </div>
      </template>
      <!-- 申请解绑 -->
      <template v-else-if="applyUnbinding">
        <app-logo :app-state="logo" />
        <div class="acConnect__text">
          <h1 class="acConnect__text-title">
            {{ logo === 'warning' ? $t('thirdPartyLogin.applyForUnbinding') : $t('thirdPartyLogin.submittedUnbinding') }}
          </h1>
          <p class="acConnect__text-descr">
            <template v-if="logo === 'warning'">
              {{ $t('thirdPartyLogin.isUnbindWeChat') }}
              <div>{{ $t('thirdPartyLogin.willNotLoginWithWeChat') }}</div>
            </template>
            <template v-else>
              {{ $t('thirdPartyLogin.unbindingDesc') }}
              <div>{{ $t('thirdPartyLogin.enterApp', { time }) }}</div>
            </template>
          </p>
        </div>
        <div
          class="acConnect__btns"
          v-loading="unbindLoading && logo === 'warning'"
        >
          <el-button
            v-if="logo === 'warning'"
            class="acConnect__btns-item"
            size="medium"
            @click="toReturnUrl"
          >
            {{ $t('common.cancel') }}
          </el-button>
          <div class="acConnect__btns-cancel">
            <el-button
              v-if="logo === 'warning'"
              class="acConnect__btns-item"
              size="medium"
              @click="unbindAccount"
              type="danger"
            >{{ $t('thirdPartyLogin.unbind') }}</el-button>
            <el-button
              v-else
              class="acConnect__btns-item"
              size="medium"
              @click="enterApp"
            >{{ $t('thirdPartyLogin.backHome') }}</el-button>
          </div>
        </div>
      </template>
      <!-- 绑定成功 -->
      <template v-else>
        <app-logo :app-state="'success'" />
        <div class="acConnect__text">
          <h1 class="acConnect__text-title">
            {{ $t('thirdPartyLogin.bindSuccessfully') }}
          </h1>
          <p class="acConnect__text-descr">
            {{ $t('thirdPartyLogin.boundDescription', { username: bindInfo.username, weixin: getNickname() }) }}
            <br>
            {{ $t('thirdPartyLogin.enterApp', { time }) }}
          </p>
        </div>
        <div class="acConnect__btns">
          <el-button
            class="acConnect__btns-item"
            size="medium"
            type="primary"
            @click="enterApp"
          >
            {{ $t('thirdPartyLogin.enterImmediately') }}
          </el-button>
        </div>
      </template>
    </div>
  </el-row>
</template>

<script>
import axios from 'axios';
import AppLogo from './components/AppLogo';

export default {
  name: 'BindWeixin',
  components: {
    AppLogo,
  },
  data() {
    return {
      pageLoading: true,
      unbindLoading: false,
      binding: false,
      successfullyBound: false,

      // 当前页面是否为「申请解绑页」
      applyUnbinding: false,
      bindInfo: {},
      logo: '',
      appLogo: 'yimian',
      tokens: {},
      urls: {
        home_url: process.env.HAMLET_URL || 'https://hamlet.flywheeldigital.com.cn',
        bindInfo: '/thirdparty/bind/info',
        miniProgramBind: '/thirdparty/weixin/miniprogram/bind',
        weixinConnect: '/thirdparty/weixin/connect',
        unbindAccount: '/thirdparty/unbind/account',
      },
      time: 6,
      timer: null,
      isMiniprogram: false,
      isForceWeixinLogin: false,
    };
  },
  computed: {
    headers() {
      const { query } = this.$route;
      const token = query.tk || query.hamlet_tk;
      if (token) {
        return {
          Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}`,
        };
      }

      return {};
    },
  },
  created() {
    const { query } = this.$route;
    if (!(query.ru && query.ak) && !(query.hamlet_a_ru && query.hamlet_tk) &&
      !(query.ak && query.tk)) {
      this.pageLoading = false;
      this.toReturnUrl();
    }

    // 这里直接使用是否有「页面返回路径 page_path」作为依据判断是否为小程序
    this.isMiniprogram = !!query.pap;
    this.isForceWeixinLogin = !!query.auk;
    if (query.hamlet_tk) {
      this.successfullyBound = true;
      this.countDown();
    } else if (this.$route.name === 'ApplyForUnbind') {
      this.logo = 'warning';
      this.applyUnbinding = true;
      this.pageLoading = false;
    }

    if (!this.applyUnbinding) {
      this.getBindInfo();
    }

    if (this.isMiniprogram) {
      this.isForceWeixinLogin = true;
      this.addWxJsSdk();
    }

    if (query.lang && this.$locale) {
      this.$locale.use(query.lang === 'en' ? 'en' : 'zh');
    }
  },
  beforeRouteLeave() {
    clearInterval(this.timer);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getBindInfo() {
      this.pageLoading = true;
      const { query } = this.$route;

      this.httpAxios(this.urls.bindInfo, {
        app_key: query.ak || query.hamlet_ak,
        auth_key: query.auk,
        auth_token: query.aut,
      }, 'GET', this.headers)
        .then((val) => {
          this.bindInfo = val.data || {};
        })
        .catch((err) => {
          console.log('>>>>err\n', err);
          if (err.status === 401) {
            this.toReturnUrl();
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.pageLoading = false;
          }, 600);
        });
    },
    addWxJsSdk() {
      const el = document.createElement('script');
      el.setAttribute('src', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js');
      document.head.appendChild(el);
    },
    httpAxios(url, data, method = 'GET', headers = {}) {
      let params = { method, url };

      if (method === 'GET') {
        params = Object.assign(params, { params: data });
      } else {
        params.data = data;
      }

      if (headers) {
        params = Object.assign(params, { headers });
      }

      // console.log('>>>>>>params', params);
      return axios(params)
        .then((res) => {
          if (res.data.ok) {
            return res.data;
          }

          return Promise.reject(res.data);
        })
        .catch((err) => {
          console.error('>>>http>>>err>>>\n', err);
          return Promise.reject(err.response || err);
        });
    },
    toBindWx() {
      this.binding = true;
      const { query } = this.$route;

      // 有 auth_token 和 auth_key 则直接绑定, 小程序
      if (query.aut && query.auk) {
        this.httpAxios(this.urls.miniProgramBind, {
          app_key: query.ak,
          auth_key: query.auk,
          auth_token: query.aut,
        }, 'POST')
          .then((val) => {
            const { data } = val;
            if (data.access_token) {
              this.successfullyBound = true;
              this.tokens = data;
              this.countDown();
            }
          })
          .catch((err) => {
            console.log('>>>>bind>>>err', err);
            const { reason } = err;
            if (reason === 'Already bind to current app') {
              this.$message.error(this.$t('thirdPartyLogin.accountHasBeenBound'));
            } else if (reason === 'This account has been bound') {
              this.$message.error(this.$t('thirdPartyLogin.accountAlreadyUsed'));
            } else {
              this.$message.error(reason);
            }
          })
          .finally(() => {
            this.binding = false;
          });
      } else {
        this.httpAxios(this.urls.weixinConnect, {
          app_key: query.ak,
          auth_key: query.auk,
          return_url: `${window.location.origin}${window.location.pathname}`,
          app_return_url: query.ru,
        }, 'POST', this.headers).then((val) => {
          console.log('>>>connect>>> successfully', val);
          window.location = val.data.url;
        })
        .catch((res) => {
          console.log('>>>connect>>> failed', res);
          const { data } = res;
          if (res.reason === 'This account has been bound') {
            this.$message.error(this.$t('thirdPartyLogin.accountHasBeenBoundToWeChat', { nickname: data.nickname }));
          } else {
            this.$message.error(this.$t('thirdPartyLogin.bindingFailed'));
          }
        })
        .finally(() => {
          this.binding = false;
        });
      }
    },
    countDown() {
      this.timer = setInterval(() => {
        this.time -= 1;
        if (this.time <= 0) {
          clearInterval(this.timer);
          this.enterApp();
        }
      }, 1000);
    },
    enterApp() {
      clearInterval(this.timer);
      const { query } = this.$route;
      if (this.isMiniprogram) {
        const wx = window.wx.miniProgram;
        const pagePath = query.pap;
        // wx.postMessage({ data: this.tokens });
        // wx.redirectTo({ url:pagePath });

        let url = `${query.ru}?tk=${this.tokens.access_token}&rtk=${this.tokens.refresh_token}`;
        url = `${pagePath}?url=${encodeURIComponent(url)}`;
        console.log('\n\n>>>url>>>\n\n', url);
        wx.navigateTo({ url });
      } else if (this.applyUnbinding) {
        // 进入到「申请解绑页」前，原有 APP 已登录
        this.toReturnUrl();
      } else {
        // 如果不是解绑页，返回原有 APP 时需要带上 token
        window.location = `${query.hamlet_a_ru}?thirdparty_connect_access_token=${query.hamlet_tk}&thirdparty_connect_refresh_token=${query.hamlet_rtk}`;
      }
    },
    toLoginPage() {
      const wx = window.wx.miniProgram;
      clearInterval(this.timer);
      wx.redirectTo({ url: '/pages/index/index' });
    },
    toReturnUrl() {
      const { query } = this.$route;
      window.location = query.ru || query.a_ru || query.hamlet_a_ru || this.urls.home_url;
    },
    getNickname() {
      if (this.bindInfo.nickname) {
        return this.bindInfo.nickname;
      }

      const tpUser = this.bindInfo.thirdparty_users;
      return tpUser && tpUser.weixin ? tpUser.weixin.nickname : '';
    },
    unbindAccount() {
      this.unbindLoading = true;
      const { query } = this.$route;
      this.httpAxios(this.urls.unbindAccount, {
        app_key: query.ak,
        type: 'weixin',
      }, 'POST', this.headers)
        .then(() => {
          this.logo = 'success';
          this.countDown();
        })
        .catch((res) => {
          console.log('unbind failed>>>', res);
          this.$message.error(this.$t('thirdPartyLogin.unbindingFailed'));
        })
        .finally(() => {
          this.unbindLoading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// BindWeixin.vue?0064789a